import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingRequest, GetPendingSCN, GetPendingSRA, GetPendingTransfer } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import ScnDetails from './ScnDetails';
import TableRow from './TableRow'
import UpdateQty from './UpdateQty';

export default function TransferApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [Id, setId] = useState("");
    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [OpenModal, setOpenModal] = useState(false);
    const [SingleData, setSingleData] = useState([]);



    const AllSRA = async () => {
        let result = await GetPendingTransfer()

        console.log("object pending transfer", result);

        if (result.status == true) {
            setData(result.queryresult)
        }
    }

    const editQty = (id) => {

        let singleInfo = Data.filter((item, i) => {
          return item._id === id
        })
        setOpenModal(true)
        setSingleData(singleInfo)
      }




      const openApprove = (id)=>{
        onOpen()
        setId(id)
      }

    useEffect(() => {

        AllSRA()

        
    }, [isOpen,OpenModal]);


    return (
        <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

            <Text p="10px" textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>

            <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

            >
                <Table variant='simple' size='sm' overflowX="auto" >
                    <Thead>
                        <Tr>
                            <Th color="#fff">S/N</Th>
                            <Th color="#fff">Name</Th>
                            <Th color="#fff">Shelf id</Th>
                            <Th color="#fff">S-Store</Th>
                            <Th color="#fff">R-Store</Th>
                            <Th color="#fff">Qty</Th>
                            <Th color="#fff">Email</Th>
                            <Th color="#fff">Approve</Th>
                          

                        </Tr>
                    </Thead>
                    <Tbody>

                        {

                            Data?.map((item, i) => (
                                <TableRow
                                    key={i}
                                    sn={i + 1}
                                    type="TransferApproval"
                                    productName={item.productname}
                                    productShelfId={item.productcode}
                                    store={item.sendingstore}
                                    storeName={item.receivingstore}
                                    qty={item.qtytotransfer}
                                    email={item.requesteremail}
                                    Approve={() => openApprove(item._id)}
                                    onClick={() => editQty(item._id)}

                                   
                                   
                                />
                            ))
                        }


                    </Tbody>

                </Table>
            </TableContainer>
            {/* this is for the approval modal that receive the type of approval*/}

            <PendingIQA isOpen={isOpen} onClose={onClose} id={Id} state="ApproveTransfer"/>
            <UpdateQty SingleData={SingleData} state="transfer" isOpen={OpenModal} onClose={()=>setOpenModal(false)} id={Id}/>



        </Box>
    )
}
